import React from "react";
import styled from "styled-components";


export default styled.h2`
    font-size: 24px;
    font-weight: 600;
    line-height: 29px;
    color: white;
    width: calc(100% - 35px);
    float: left;
    text-align: left;
    
    
    @media(max-width: 768px) { 
        width: 100%;
    }
`;